import { z } from "zod";

export const zUid = z.number().or(z.string());

export type ZUid = z.infer<typeof zUid>;
